import React from 'react'

export default function UiLookUpDataInputWr(props) {

    return (

        <div className='sba-lookupdata-input-wr' {...props} />

    )
}

